import i18n from 'i18next';

import Config from '../../Config/Config';
import usePageLanguagePrefix from '../../hooks/UsePageLanguagePrefix';

// Route Name: translated route key
const routes: Record<string, string> = {
    results: 'routes.results',
    'results.all': 'routes.results_all',
    rules: 'routes.rules',
    'rules.all': 'routes.rules_all',
    faq: 'routes.faq',
    singlenews: 'routes.news_single',
    news: 'routes.news',
    play: 'routes.play_single',
    'play.all': 'routes.play_all',
    howtoplay: 'routes.how_to_play',
    'howtoplay.all': 'routes.how_to_play_all',
    'blog.display': 'routes.blog',
    contact: 'routes.contact',
    casinoNews: 'routes.casinoNews',
    casinoNewsSingle: 'routes.casinoNewsSingle',
};

interface ParamsInterface {
    [key: string]: string | undefined;
}

export function Route(routeName: string, routeOptions: ParamsInterface = {}) {
    let route = routes[routeName];

    if (!route) {
        return null;
    }

    route = translateRoute(route, Boolean(routeOptions.casino_slug));
    route = transformRoute(route, routeOptions);

    return route;
}

function translateRoute(route: string, hasCasinoSlug: boolean): string {
    let translatedRoute = i18n.t(route);

    if (hasCasinoSlug) {
        translatedRoute = removeCasinoPrefix(translatedRoute);
    }

    return translatedRoute;
}

function transformRoute(route: string, routeOptions: ParamsInterface = {}): string {
    // Replace route params
    let transformedRoute = `/${route.replace(/\{([^}]+)\}/g, (_, param) => routeOptions[param] || '')}`;

    if (Config.isNot('app.locale', document.documentElement.lang)) {
        transformedRoute = `/${document.documentElement.lang}${transformedRoute}`;
    }

    return addTrailingSlashToUrl(transformedRoute);
}

export function addTrailingSlashToUrl(url: string, hasParams: boolean = false): string {
    if (Config.isFalse('seo.add_trailing_slash_to_urls')) {
        return url;
    }

    if (url.includes('?') || hasParams) {
        return url;
    }

    return `${url}/`;
}

/**
 * When casino is on subdomain or foreign subdomain,
 * we need to remove the casino prefix from the route
 */
function removeCasinoPrefix(route: string) {
    if (Config.get('casino.page_mode') === 'page') {
        return route;
    }

    return route.replace('{casino_slug}/', '');
}
